import { render, staticRenderFns } from "./MailSearchModal.vue?vue&type=template&id=fd9b6d06"
import script from "./MailSearchModal.vue?vue&type=script&lang=js"
export * from "./MailSearchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports